import React from "react";
import { Link } from "react-router-dom";
import classes from "./Logo.module.scss";
import ticklerLogo from "../../assets/icons/logo/tickler_logo.svg";

const logo = (props) => {
  return (
    <Link
      to={localStorage.getItem("login") ? "/" : "/login"}
      className={[classes["logo"], "d-flex"].join(" ")}
    >
      <img alt="Tikler" width="98" src={ticklerLogo} className="img-fluid" />
    </Link>
  );
};

export default logo;
